import { render, staticRenderFns } from "./TableArea.vue?vue&type=template&id=d941c704&"
import script from "./TableArea.vue?vue&type=script&lang=js&"
export * from "./TableArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports